import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { modernTableStyle, modernTableOptions, MercosulPlateBadge } from '../common/tableTheme';

export default function DriverEarning() {
  
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();

  const columns =  [
      { title: t('year') || 'Ano', field: 'year', cellStyle: { fontWeight: 600 } },
      { title: t('months') || 'Mês', field: 'monthsName' },
      { title: t('driver_name') || 'Condutor', field: 'driverName', cellStyle: { fontWeight: 600, color: '#0f172a' } },
      { title: t('booking_count') || 'Total de Rotas', field: 'total_rides', cellStyle: { fontWeight: 700, color: '#2563eb' } },
      { title: t('vehicle_reg_no') || 'Placa', field: 'driverVehicleNo', render: rowData => <MercosulPlateBadge plate={rowData.driverVehicleNo} />, cellStyle: { textAlign: 'center' } },
      { title: t('earning_amount') || 'Remuneração / Repasse', field: 'driverShare', cellStyle: { fontWeight: 600 } }
  ];

  const [data, setData] = useState([]);
  const driverearningdata = useSelector(state => state.driverearningdata);

  useEffect(()=>{
        if(driverearningdata.driverearnings){
            setData(driverearningdata.driverearnings);
        }
  },[driverearningdata.driverearnings]);

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    driverearningdata.loading? <CircularLoading/>:
    <MaterialTable
      title=""
      columns={columns}
      style={modernTableStyle}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={modernTableOptions(selectedRow, {
        grouping: true,
        searchPlaceholder: "Buscar por motorista, mês, placa...",
        maxBodyHeight: "calc(100vh - 280px)"
      })}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
      }}
      
    />
  );
}
